import React from 'react';
import { getProject } from '../../content/portfolioContent';
import './Connect.css';

const projects = ['loom', 'world-authoring-lab', 'digital-drafter'].map((slug) => ({
  ...getProject(slug),
  href: '/projects/' + slug
}));

const Connect = () => {
  return (
    <main className="connect-page">
      <nav className="connect-nav" aria-label="Connect page navigation">
        <a className="connect-brand" href="/">Robert Miller</a>
        <a className="connect-nav-link" href="/">Full portfolio</a>
      </nav>

      <section className="connect-hero" aria-labelledby="connect-heading">
        <p className="connect-eyebrow">AI systems · Software architecture</p>
        <h1 id="connect-heading">Hi, I’m Robert.</h1>
        <p className="connect-intro">
          We may have met at an AI conference. I work on practical AI systems, software architecture,
          and tools that make messy work more navigable. Here are the best places to start.
        </p>

        <div className="connect-actions" aria-label="Best places to start">
          <a
            className="connect-action connect-action-primary"
            href="https://www.linkedin.com/in/rpmiller4"
            target="_blank"
            rel="noreferrer"
          >
            Connect on LinkedIn
            <span aria-hidden="true">↗</span>
          </a>
          <a className="connect-action connect-action-secondary" href="/#showcase">
            See selected work
          </a>
          <a
            className="connect-action connect-action-secondary"
            href="https://froggy.dunelabs.io"
            target="_blank"
            rel="noreferrer"
          >
            Try Froggy World
            <span aria-hidden="true">↗</span>
          </a>
        </div>
      </section>

      <section className="connect-work" aria-labelledby="connect-work-heading">
        <div className="connect-section-heading">
          <h2 id="connect-work-heading">Selected work</h2>
        </div>

        <div className="connect-project-grid">
          {projects.map((project) => (
            <article className="connect-project-card" key={project.slug}>
              <h3>{project.homeTitle || project.title}</h3>
              <p>{project.homeSummary || project.summary}</p>
              <a href={project.href}>Read the project overview <span aria-hidden="true">→</span></a>
            </article>
          ))}
        </div>
      </section>

      <section className="connect-contact" aria-labelledby="connect-contact-heading">
        <div>
          <p className="connect-section-kicker">Keep the conversation going</p>
          <h2 id="connect-contact-heading">The easiest next step is LinkedIn.</h2>
          <p>I keep this page intentionally light on personal contact details. The card has the direct ones.</p>
        </div>
        <a
          className="connect-action connect-action-primary"
          href="https://www.linkedin.com/in/rpmiller4"
          target="_blank"
          rel="noreferrer"
        >
          Open LinkedIn
          <span aria-hidden="true">↗</span>
        </a>
      </section>

      <footer className="connect-footer">
        <span>Robert Miller</span>
        <span>All content copyright Robert Miller © 2023–2026</span>
      </footer>
    </main>
  );
};

export default Connect;
